import "./jquery";
require("bootstrap/js/transition.js");
require("bootstrap/js/collapse.js");
require("bootstrap/js/modal.js");



// WEBPACK FOOTER //
// ./src/include/bootstrap.js